import { Box } from "@mui/material";

interface ChatStickerProps {
  url: string;
  size?: 'regular' | 'compact';
}

export const ChatSticker: React.FC<ChatStickerProps> = ({ url, size = 'regular' }) => {
  const dims = size === 'compact'
    ? { maxW: 120, maxH: 120 }
    : { maxW: 150, maxH: 150 };
  return (
    <Box
      component="img"
      src={url}
      alt="Sticker"
      sx={{
        maxWidth: dims.maxW,
        maxHeight: dims.maxH,
        objectFit: "contain"
      }}
    />
  );
}; 